module.exports = __webpack_public_path__ + "img/Slack_Mark_Monochrome_White.87efa5e3.png";